import React, { useState, useContext, useMemo } from "react"
import Card from '../nura/card/card'
import { withModal } from '../modal/modal'
import RunBlueprintContext, { useInitRunBlueprint } from '../../context/run-blueprint.context'
import { BlueprintInput } from "./run-blueprint"
import Button from "../nura/button/button"
import BaseForm from "../base-form/base-form"
import { isValueSet } from '../../util/util'
import styles from './styles.module.css'
import { CircularProgress } from "@mui/material"

export default withModal(({ inputs, name, defaultValues = {}, onSubmit, onClose }) => {
    const ctx = useInitRunBlueprint()

    const [validationError, setValidationError] = useState()
    const { isLoading } = useContext(RunBlueprintContext)

    const currentStepInput = useMemo(() => inputs[0], [inputs])

    const [value, setValue] = useState(defaultValues[currentStepInput?.id])

    const submitValues = () => {
        if (isValueSet(value)) {
            onSubmit(currentStepInput?.id, value)
        }
    }

    return (
        <>
            <RunBlueprintContext.Provider value={ctx}>
                <Card variant="modal" style={{ minWidth: 358, height: 'auto', maxWidth: 800 }}>
                    <BaseForm onBack={onClose} title={`Set default for ${name}`}>
                        <div className={styles.textAreaContainer}>
                            <BlueprintInput
                                type={currentStepInput?.type}
                                value={value}
                                onChange={setValue}
                                name={currentStepInput?.name}
                                setValidationError={setValidationError}
                                formValues={{}}
                            />
                            {validationError?.message !== undefined && (
                                <div style={{ color: 'red', marginTop: 7, fontSize: 14, width: 345 }}>
                                    {validationError?.message}
                                </div>
                            )}
                        </div>
                        <div className={styles.actionGroup}>
                            <Button
                                onClick={submitValues}
                                style={{ width: '100%' }}
                                variant="outline"
                                disabled={isLoading}
                            >
                                {
                                    isLoading ? (
                                        <CircularProgress size={20} />
                                    ) :
                                        (
                                            <>Set</>
                                        )
                                }
                            </Button>
                        </div>
                    </BaseForm>
                </Card>
            </RunBlueprintContext.Provider>
        </>
    )
})